<template>
    <div v-scroll="animateOnScroll" ref="project" class="project"
    :style="{backgroundColor: this.db.content.color}">
        <k-nav></k-nav>
        <k-header></k-header>
        <div 
          ref="projectMain"
          class="project--main"
          :style="{backgroundImage: 'url(../' + db.content.source + ')'}">
          <p ref="title" class="project--main--title">{{ db.content.title }}</p>
        </div>
        <div class="project--content">
          <p ref="description" class="project--content--description">
            {{ db.content.description }}
            <span class="author">{{ db.content.author }}</span>
          </p>
          <div class="project--content--images">
            <img ref="image1" :src="'../' + db.content.images[0]" alt="project-image">
            <img ref="image2" :src="'../' + db.content.images[1]" alt="project-image">
          </div>
          <div 
            ref="full"
            class="project--content--full"
            :style="{backgroundImage: 'url(../' + db.content.images[2] + ')'}">
          </div>
        </div>
        <div class="project--bottom" :style="{backgroundColor: db.nextContent.color}">
          <p class="project--next">Next project</p>
            <router-link 
              tag="div"
              :to="{name: 'project', params: {'title': db.nextContent.title.toLowerCase()}}"
              class="project--link"
              :style="{backgroundImage: 'url(../' + db.nextContent.source + ')'}">
              <p class="project--main--title">
                {{ db.nextContent.title }}
              </p>
            </router-link>
          <k-footer ref="footer"></k-footer>
        </div>
    </div>
</template>

<script>
import Header from './Header';
import Nav from './Nav';
import Footer from './Footer';
import DB from '../database/Base';
import { TweenMax, Expo } from 'gsap';

export default {
  components: {
    'k-header': Header,
    'k-nav': Nav,
    'k-footer': Footer
  },

  data() {
    return {
      animationDone: []
    }
  },

  computed: {
    db() {
      let title = this.$route.params.title; 
      title = title.charAt(0).toUpperCase() + title.slice(1);
      let projectContent = DB.filter(project => (project.title === title));
      let index = DB.map(e => e.title).indexOf(title);

      if (index < DB.length - 1) {
        index++;
      } else {
        index = 0
      }

      return {
        content: projectContent[0],
        nextContent: DB[index]
      }
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    this.animateMount();
  },

  beforeUpdate() {
    window.scrollTo(0, 0);
    this.animateUpdate();
  },

  methods: {
    animateMount() {
      const {project} = this.$refs;

      this.animationDone = [];
      this.hideElements();

      const tl = new TimelineMax();
      tl
      .fromTo(project, 1, {backgroundColor: '#161919'}, {backgroundColor: this.db.content.color, ease: Expo.easeOut});
    },

    animateUpdate() {
      const {projectMain} = this.$refs;

      this.animationDone = [];
      this.hideElements();

      const tl = new TimelineMax();
      tl
      .fromTo(projectMain, 1, {opacity: 0, scale: 1.3}, {opacity: 1, scale: 1, ease: Expo.easeInOut});
    },

    animateOnScroll() {

      if (this.animationDone.length < 4) {
        const {description, image1, image2, full} = this.$refs;
        const tl = new TimelineMax();

        if (window.scrollY > 350 && !this.animationDone.includes(description)) {
          this.show(description);
        }
        if (window.scrollY > 750 && !this.animationDone.includes(image1) && !this.animationDone.includes(image2)) {
          this.show(image1);
          setTimeout(() => {
            this.show(image2);
          }, 500);
        }
        if (window.scrollY > 1500 && !this.animationDone.includes(full)) {
          this.show(full);
        }
      }
    },

    show(el) {
      const tl = new TimelineMax();
      tl.to(el, 1.5, {opacity: 1});
      this.animationDone.push(el);
    },
    
    hide(el) {
      const tl = new TimelineMax();
      tl.to(el, 1, {opacity: 0});
    },

    hideElements() {
      const {project, description, image1, image2, full} = this.$refs;

      this.hide(description);
      this.hide(image1);
      this.hide(image2);
      this.hide(full);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Project.vue